import { ENV_DEV } from "../../../utils/window";
import getOptionShorthand from "./get-option-shorthand";

/**
 * Get options "name" and "rest"
 * @param {String} input
 * @param {Boolean} [isOption]
 * @returns {Map<"name" | "rest", String>}
 */
const getOptionData = (input, isOption) => {
  /** Final result */
  const map = new Map();

  /**Split the option name and its value */
  const split = input.split("˸");

  /** Get the "name" and the "rest" (parameters) with possible shorthand name */
  const data = getOptionShorthand(split[0] || "", split[1] || "", isOption);

  /** Option actual name */
  const name = data.get("name");

  /** Rest (parameters) */
  const rest = data.get("rest");

  /** In case the option name (or shorthand) does't exists */
  if (ENV_DEV && !name) {
    console.warn(
      `[TorusKit warn]: Unknown option \`${input.replace(/_/g, ":")}\``
    );
  }

  map.set("name", name);
  map.set("rest", rest);

  return map;
};

export default getOptionData;
